<template>
	<div class="mb-1 font-semibold text-black uppercase">
		<slot />
	</div>
</template>
